<template>
  <div class="grid">
    <loading
      :active="isLoadingModel"
      :can-cancel="true"
      color="#274461"
      :is-full-page="fullPage"
    ></loading>
    <Toast />
    <div class="col-12 sticky">
      <div id="custom_card" class="card">
        <div class="grid justify-content-between">
          <div class="col-12 md:col-6">
            <div
              class="flex flex-wrap align-items-center justify-content-center md:justify-content-start md:mb-0 mb-3"
            >
              <p style="color: #3f51b5; font-size: 20px; font-weight: 800">
                {{ $t("asset_type") }}
              </p>
            </div>
          </div>
          <div class="col-12 md:col-6">
            <div
              class="flex flex-wrap align-items-center justify-content-end md:justify-content-end md:mb-0 mb-3"
            >
              <Button
                iconPos="right"
                :label="$t('add')"
                v-tooltip.bottom="$t('add')"
                icon="pi pi-plus"
                @click="openNew"
                size="small"
                style=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="card" id="custom_card">
        <div class="grid p-fluid">
          <div class="col-12 md:col-12">
            <div class="p-fluid formgrid grid">
              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                  <InputText
                    format="text"
                    v-model="search_filter"
                    @input="search(1)"
                  >
                  </InputText>
                  <label>{{ $t("search_type") }}</label>
                </span>
              </div>
              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                  <Dropdown
                    id="status"
                    v-model="status_dropdownItem"
                    :options="status_dropdownItems"
                    optionLabel="name"
                    filter
                    @change="search(1)"
                  >
                  </Dropdown>
                  <label for="status">{{ $t("status") }}</label>
                </span>
              </div>
              <div class="field col-2 md:col-2">
                <Button
                  icon="pi pi-refresh"
                  v-tooltip.bottom="$t('refresh')"
                  @click="search(2)"
                  class="p-button-danger"
                  style=""
                />
              </div>
            </div>
          </div>
        </div>
        <DataTable
          :loading="loading"
          ref="dt"
          :lazy="true"
          :totalRecords="totalRecords"
          :paginator="true"
          :value="products"
          v-model:selection="selectedProducts"
          :dataKey="columns[0]"
          :rows="limit"
          :filters="filters"
          @page="onPage($event)"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="PerPageOptions"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          responsiveLayout="scroll"
          style="font-size: 12px"
          :rowHover="true"
          showGridlines
        >
          <template #empty>
            <b style="text-align: center">{{ $t("no_rec") }}</b>
          </template>
          <template #header>
            <div style="text-align: right; font-weight: bold">
              <span>{{ $t("total_asset_type") }}:</span>{{ totalRecords }}
            </div>
          </template>
          <Column
            :header="$t('status')"
            style="min-width: 8rem; text-align: center"
            :field="columns[5]"
          >
            <template #body="{ data }">
              <span v-if="data.is_active == '1' || data.is_active == '1'"
                ><badge
                  class="p-button-success"
                  value="Active"
                  severity="success"
                ></badge
              ></span>
              <span v-else-if="data.is_active == '2' || data.is_active == '2'"
                ><badge
                  class="p-button-warning"
                  value="In Active"
                  severity="warning"
                ></badge
              ></span>
              <span v-else-if="data.is_active == '3' || data.is_active == '3'"
                ><badge
                  class="p-button-danger"
                  value="Deleted"
                  severity="danger"
                ></badge
              ></span>
              <span v-else>-</span>
            </template>
          </Column>
          <Column :header="$t('asset_type')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.asset_type }}
            </template>
          </Column>
          <Column :header="$t('asset_type_mr')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.asset_type_mr }}
            </template>
          </Column>
          <Column :header="$t('rate_of_depreciation')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.rate_of_depreciation }}
            </template>
          </Column>
          <Column :header="$t('remarks')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.remarks }}
            </template>
          </Column>
          <Column :header="$t('action')" headerStyle="min-width:5rem;">
            <template #body="slotProps">
              <Button
                v-if="slotProps.data.is_active != 3"
                icon="pi pi-pencil"
                title="$t('edit_client')"
                v-tooltip.bottom="$t('edit')"
                class="p-button-rounded p-button-success mr-2"
                @click="editProduct(slotProps.data)"
                style=""
              />
              <Button
                v-if="slotProps.data.is_active != 3"
                icon="pi pi-trash"
                v-tooltip.bottom="$t('delete')"
                class="p-button-rounded p-button-danger mt-2"
                @click="confirmDeleteProduct(slotProps.data)"
                style=""
              />
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
    <Dialog
      v-model:visible="productDialog"
      :breakpoints="{ '960px': '75vw' }"
      :style="{ width: '35vw' }"
      :header="$t('asset_type')"
      :modal="true"
      position="top"
    >
      <div class="col-12">
        <div class="p-fluid formgrid grid" style="margin-top: 2%">
          <div class="field col-12 md:col-12" style="margin-top: 3%">
            <span class="p-float-label">
              <InputText
                id="ticket_title"
                type="text"
                v-model="product.asset_type"
              />
              <label for="name">{{ $t("asset_type") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-12" style="margin-top: 3%">
            <span class="p-float-label">
              <InputText
                id="ticket_title"
                type="text"
                v-model="product.asset_type_mr"
              />
              <label for="name">{{ $t("asset_type_mr") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-12" style="margin-top: 3%">
            <span class="p-float-label">
              <InputText
                id="rate_of_depreciation"
                type="number"
                v-model="product.rate_of_depreciation"
              />
              <label for="name">{{ $t("rate_of_depreciation") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-12" style="margin-top: 3%">
            <span class="p-float-label">
              <Textarea
                rows="6"
                id="remarks"
                type="text"
                v-model="product.remarks"
              />
              <label for="name">{{ $t("remarks") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-12" style="margin-top: 3%">
            <span class="p-float-label">
              <Dropdown
                id="status"
                v-model="addeditstatus_dropdownItem"
                :options="status_dropdownItems"
                optionLabel="name"
                filter
                :disabled="!product._id"
              >
              </Dropdown>
              <label for="status">{{ $t("status") }}</label>
            </span>
          </div>
        </div>
      </div>
      <template #footer>
        <Button
          :label="$t('save')"
          @click="save_event"
          icon="pi pi-check"
          class="p-button-success"
        />
      </template>
    </Dialog>
    <Dialog
      v-model:visible="deleteProductDialog"
      :style="{ width: '450px' }"
      :header="$t('Confirm')"
      :modal="true"
    >
      <div class="flex align-items-center justify-content-center">
        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
        <span v-if="product"
          >{{ $t("delete_msg") }}<b>{{ product.asset_type }}</b
          >?</span
        >
      </div>
      <template #footer>
        <Button
          :label="$t('no')"
          icon="pi pi-times"
          class="p-button-text"
          @click="deleteProductDialog = false"
        />
        <Button
          :label="$t('yes')"
          icon="pi pi-check"
          class="p-button-text"
          @click="deleteevent"
        />
      </template>
    </Dialog>
  </div>
</template>
  <script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "../service/ProductService";
import apis from "@/apis";
import axios from "axios";
export default {
  data() {
    return {
      status_dropdownItems: [
        { name: "Active", value: "1" },
        { name: "In Active", value: "2" },
        { name: "Deleted", value: "3" },
      ],
      status_dropdownItem: null,
      addeditstatus_dropdownItem: null,
      search_filter: "",
      user_key: "",
      page_no: 1,
      isLoading: false,
      PerPageOptions: [10, 50, 100],
      isLoadingModel: false,
      loading: false,
      fullPage: true,
      products: null,
      productDialog: false,
      deleteProductDialog: false,
      deleteProductsDialog: false,
      lazyParams: {},
      product: {},
      selectedProducts: null,
      filters: {},
      offset: 1,
      limit: 10,
      columns: [],
      pageno: 1,
      submitted: false,
      totalRecords: 0,
      id: "",
    };
  },
  productService: null,
  async created() {
    this.productService = new ProductService();
    this.initFilters();
    this.user_key = localStorage.getItem("user_type");
  },
  async mounted() {
    this.id = this.$route.params.id;
    this.lazyParams = {
      first: 0,
      rows: this.limit,
      sortField: null,
      sortOrder: null,
      filters: this.filters,
    };
    if (this.totalRecords == 0) {
      await this.get_count();
    }
    await this.get_list();
  },
  watch: {
    async $route() {
      this.products = [];
      this.columns = [];
      this.totalRecords = 0;
      this.id = this.$route.params.id;
      if (this.id) {
        await this.get_count();
        this.get_list();
      }
    },
  },
  watch: {
    currentLocale() {},
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale;
    },
  },
  methods: {
    async save_event() {
      if (!this.product.asset_type) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_asset_type"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.asset_type_mr) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_asset_type_mr"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.rate_of_depreciation) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_rate_of_depreciation"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.remarks) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_remarks"),
          life: 3000,
        });
        return false;
      }
      if (!this.addeditstatus_dropdownItem) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_status"),
          life: 3000,
        });
        return false;
      }
      var details = {};
      if (this.product._id) {
        details = {
          _id: this.product._id,
          asset_type: this.product.asset_type,
          asset_type_mr: this.product.asset_type_mr,
          remarks: this.product.remarks,
          rate_of_depreciation: this.product.rate_of_depreciation.toString(),
          updated_by: localStorage.getItem("id"),
          is_active: this.addeditstatus_dropdownItem?.value,
          lang: this.$i18n.locale,
        };
        var promise = apis.updateAssetType(details);
      } else {
        details = {
          asset_type: this.product.asset_type,
          asset_type_mr: this.product.asset_type_mr,
          remarks: this.product.remarks,
          rate_of_depreciation: this.product.rate_of_depreciation.toString(),
          created_by: localStorage.getItem("id"),
          is_active: this.addeditstatus_dropdownItem?.value,
          client_id: localStorage.getItem("client_id"),
          lang: this.$i18n.locale,
        };
        var promise = apis.createAssetType(details);
      }
      this.isLoadingModel = true;
      promise.then((response) => {
        this.isLoadingModel = false;
        if (response.data.status == true) {
          this.$toast.add({
            severity: "success",
            summary: "success",
            detail: response.data.message,
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: response.data.message,
            life: 3000,
          });
        }
        this.productDialog = false;
        this.get_list();
        this.get_count();
      });
    },
    async search(count) {
      if (count == 2) {
        this.search_filter = "";
        this.status_dropdownItem = null;
      }
      await this.get_list();
      await this.get_count();
    },
    async onPage(event) {
      this.lazyParams = event;
      this.page_no = event.page + 1;
      this.limit = event.rows;
      // console.log(event);
      //  await this.get_count();
      if (this.totalRecords > 0) {
        this.get_list();
      }
    },
    get_count: function () {
      var data = {
        client_id: localStorage.getItem("client_id"),
        is_active: this.status_dropdownItem?.value,
        search: this.search_filter,
        count: true,
        //AsOnDate: "",
      };
      this.loading = true;
      var promise = apis.listAssetTypes(data, this.id);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        this.totalRecords = response.data.data;
        if (this.totalRecords > 100) {
          this.PerPageOptions.push(this.totalRecords);
        }
        //alert(this.totalRecords);
      });
      console.log(data);
    },
    get_list: function () {
      var data = {
        client_id: localStorage.getItem("client_id"),
        is_active: this.status_dropdownItem?.value,
        search: this.search_filter,
        count: false,
        page_no: this.page_no,
        limit: this.limit,
        //AsOnDate: "",
      };
      this.loading = true;
      var promise = apis.listAssetTypes(data, this.id);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        this.products = response.data.data;
        console.log(this.products[0]);
        if (this.columns.length == 0) {
          if (this.products.length > 0) {
            this.columns = Object.keys(this.products[0]);
          }
        }
      });
      console.log(data);
    },
    openNew() {
      this.product = {};
      this.submitted = false;
      this.productDialog = true;
      this.addeditstatus_dropdownItem = { name: "Active", value: "1" };
    },
    async editProduct(product) {
      this.file_attachment = "";
      this.product = { ...product };
      this.addeditstatus_dropdownItem = null;
      if (this.product.is_active) {
        const statusMap = {
          1: "Active",
          2: "In Active",
          3: "Deleted",
        };
        const name = statusMap[this.product.is_active] || "";
        this.addeditstatus_dropdownItem = {
          name,
          value: this.product.is_active.toString(),
        };
      }
      this.productDialog = true;
    },
    confirmDeleteProduct(product) {
      this.product = product;
      this.deleteProductDialog = true;
    },
    deleteevent() {
      if (this.product._id) {
        var data = {
          _id: this.product._id,
          asset_type: this.product.asset_type,
          asset_type_mr: this.product.asset_type_mr,
          remarks: this.product.remarks,
          rate_of_depreciation: this.product.rate_of_depreciation.toString(),
          updated_by: localStorage.getItem("id"),
          is_active: 3,
          lang: this.$i18n.locale,
        };
        this.isLoadingModel = true;
        var promise = apis.updateAssetType(data);
        promise.then((responseapi) => {
          this.isLoadingModel = false;
          if (responseapi.data.status == true) {
            this.$toast.add({
              severity: "success", // success, info, warn, error
              summary: this.$t("success"),
              detail: responseapi.data.message,
              life: 3000, // Toast disappears after 3 seconds
            });
            this.deleteProductDialog = false;
            this.get_list();
            this.get_count();
          } else {
            this.$swal("error to Delete Asset Type");
          }
        });
      }
    },
    async exportCSV() {
      this.limit = this.totalRecords;
      this.get_list();
      await this.$refs.dt.exportCSV();
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
  components: {},
};
</script>
  <style scoped lang="scss">
@import "../assets/demo/badges.scss";
</style>
  